import { HIDE_SALARY } from '@/common';
import type { JobSummary } from './model';

type JobLinkPreviewData = Pick<
  JobSummary,
  | 'company'
  | 'employmentType'
  | 'employmentTypeName'
  | 'jobTitle'
  | 'prettySalary'
  | 'workingArrangement'
  | 'workingLocations'
>;

function getCompanyDisplayName(companyName: string | null | undefined): string {
  return companyName?.trim() || '';
}

function getLocationLabel(
  workingLocations: string[] | null | undefined
): string {
  const uniqueLocations = [
    ...new Set((workingLocations ?? []).map(location => location?.trim())),
  ].filter(Boolean);

  if (uniqueLocations.length === 0) {
    return '';
  }

  if (uniqueLocations.length === 1) {
    return uniqueLocations[0];
  }

  if (uniqueLocations.length === 2) {
    return uniqueLocations.join(', ');
  }

  return `${uniqueLocations[0]} và ${uniqueLocations.length - 1} địa điểm khác`;
}

function getVisibleSalary(prettySalary: string | null | undefined): string {
  const salary = prettySalary?.trim();

  if (!salary || salary === HIDE_SALARY) {
    return '';
  }

  return salary;
}

export function getJobLinkPreviewTitle(job: JobLinkPreviewData): string {
  const companyDisplayName = getCompanyDisplayName(job.company.name);

  return companyDisplayName
    ? `Tuyển ${job.jobTitle} tại ${companyDisplayName}`
    : `Tuyển ${job.jobTitle} trên Upzi`;
}

export function getJobLinkPreviewDescription(job: JobLinkPreviewData): string {
  const sections: string[] = [];
  const locationLabel = getLocationLabel(job.workingLocations);
  const salary = getVisibleSalary(job.prettySalary);
  const workType = job.employmentTypeName?.trim() || job.employmentType?.trim();
  const workArrangement = job.workingArrangement?.trim();

  if (locationLabel) {
    sections.push(`Tại ${locationLabel}`);
  }

  if (salary) {
    sections.push(`Lương ${salary}`);
  }

  if (workType) {
    sections.push(workType);
  }

  if (workArrangement) {
    sections.push(workArrangement);
  }

  return sections.length > 0
    ? `${sections.join('. ')}.`
    : 'Xem chi tiết việc làm trên Upzi.';
}
